import { createApp } from "vue";
import Vant, { showNotify, closeNotify } from "vant";
import App from "./App.vue";
import { router } from "./router";
import { hall } from "./network/hall-connection";
import { stopBalanceStream } from "./network/balance-stream";
import "./styles/global.css";
import "./styles/application.css";

function resize() {
  const game = document.documentElement.classList.contains("game-active");
  const width = game ? Math.min(innerWidth, innerHeight) : innerWidth;
  document.documentElement.style.setProperty(
    "font-size", `${width >= 768 ? 50 : width / 10}px`, game ? "important" : "",
  );
}
resize();
addEventListener("resize", resize);
router.afterEach((to) => {
  document.documentElement.classList.toggle("game-active", to.path === "/gameMingxing97");
  resize();
});
window.addEventListener("session-ended", () => {
  hall.close();
  stopBalanceStream();
  void router.replace("/");
});
window.addEventListener("server-navigation", (event) => {
  void router.replace((event as CustomEvent<string>).detail);
});
window.addEventListener("online", closeNotify);
window.addEventListener("offline", () => showNotify({
  message: "无法访问互联网,请检查网络连接", duration: 0,
  color: "#ffffff", background: "#ee0a24",
}));
const app = createApp(App);
app.config.errorHandler = (error) => {
  console.error(error);
};
app.use(Vant).use(router).mount("#app");
if ("serviceWorker" in navigator && import.meta.env.PROD)
  navigator.serviceWorker
    .register("/service-worker.js", { updateViaCache: "none" })
    .catch((error) => console.error("Cache worker update failed", error));
